import Vue from 'vue'
import VueI18n from 'vue-i18n'
import languageMapping from '@/i18n/languageMapping'

import en from '@/i18n/en-US/index'
import cn from '@/i18n/zh-CN/index'
import cntw from '@/i18n/zh-TW/index'
import fr from '@/i18n/fr/index'
import pt from '@/i18n/pt/index'
import ja from '@/i18n/ja/index'

Vue.use(VueI18n)

var lang = languageMapping(window.navigator.language)
const locales = {
  'en-US': en,
  'zh-CN': cn,
  'zh-TW': cntw,
  'en': en,
  'fr': fr,
  'pt': pt,
  'ja': ja
}
const i18n = new VueI18n({
  locale: lang,
  messages: locales 
})
export default i18n

